module.exports = __webpack_public_path__ + "img/778-fa47c4.png";